<template src="./index.html"></template>
<style lang="scss" src="./index.scss" scoped></style>
<style lang="less">
#CustomerWarn .van-tabbar {
  z-index: 20;
}
</style>
<script>
import { Dialog, Popup, DatetimePicker, Checkbox, CheckboxGroup,Cell ,CellGroup, NoticeBar } from "vant";
import { mapState } from "vuex";
import DownScrollLoad from "@/utils/DownScrollLoad";
import LostPage from "@/components/LostPage";
import SelfTabbar from '@/components/SelfTabbar';
import MerchantsDay20210312 from '@/components/MerchantsDay20210312_APP';
import ManualHelp from '@/components/ManualHelp_APP';
import CouponsPopup from "@/components/CouponsPopup";
import { URL5 } from "@/utils/Redirect";
export default {
  name: "CustomerWarn",
  components: { Dialog, Popup,NoticeBar, ManualHelp, CouponsPopup, DatetimePicker, LostPage, Checkbox, CheckboxGroup,Cell ,CellGroup, SelfTabbar, MerchantsDay20210312 },
  data() {
    return {
      TabbarActive: 2,
      listArr: [],
      allChooseActive: false,
      tanDivShow: false,
      timeShow: false,
      currentDate: "",
      minDate: '',
      maxDate: new Date(),
      timeIndex: null,
      lostPageShow: false,
      dataShow: false,
      lastText: false,
      titleArr: [{name: '全部预警',value:'all', message:0},
              {name: '客单价预警', value:'custom',message:0},
              {name: '超期未购预警',value:'overday', message:0},
              {name: '交易金额预警',value:'amount', message:0}],
      titleIndex: 0,
      dataObj: {},
      warning_type: 'all',
      visitor_id: '932187851',
      data: [],
      lostShow: false,
      sendMassage: false,
      userInfo: [],
      noRootShow: false,
      popup_show: null, //微信打开的遮罩
      popup_img: "", //遮罩的图片
      requestType: false, //判断请求状态
      scrollBottomValue: '',
    };
  },
  computed: {
    ...mapState({
      getSappMenuInfo: (state) => {
        return state.Public.getSappMenuInfo;
      },
      CustomerWarnData: (state) => {
        return state.CustomerWarn.CustomerWarnData;
      },
      warnListLength: (state) => {
        return state.CustomerWarn.warnListLength;
      },
      WarnPage: (state) => {
        return state.CustomerWarn.WarnPage;
      },
      scrollTopValue: (state) => {
        return state.CustomerWarn.scrollTopValue;
      },
      saveMinTime: (state) => {
        return state.CustomerWarn.saveMinTime;
      },
      startTime: (state) => {
        return state.CustomerWarn.startTime;
      },
      endTime: (state) => {
        return state.CustomerWarn.endTime;
      },
    }),
  },
  methods: {


    scrollEvent(e) {
      this.scrollValue = e.srcElement.scrollTop
      this.$store.commit("CustomerWarn/SET_DATA", {
        key: "scrollTopValue",
        data: this.scrollValue,
      });
      if (e.srcElement.scrollHeight - (e.srcElement.scrollTop + e.srcElement.clientHeight) < 40 ) {
        if(this.scrollBottomValue < e.srcElement.scrollTop) {
          this.getData()
        }
        this.scrollBottomValue = e.srcElement.scrollTop
      }
    },


    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    // 初始化数据
    getData() {
      this.dataObj.start_time = this.startTime
      this.dataObj.end_time = this.endTime
      this.dataObj.page = this.WarnPage
      this.dataObj.visitor_id = this.visitor_id
      this.dataObj.warning_type = this.warning_type
      if(!this.requestType) {
        this.requestType = true
        this.$store.dispatch("CustomerWarn/CustomerWarning", this.dataObj).then((res) => {
          if(res.start_time) {
            this.requestType = false
          }
          this.$store.commit("CustomerWarn/SET_DATA", {
            key: "startTime",
            data: this.startTime == '' ?res.default_start_time :this.startTime
          });
          this.$store.commit("CustomerWarn/SET_DATA", {
            key: "endTime",
            data: this.endTime == '' ?res.default_end_time :this.endTime
          });
          this.getSappMenuInfo.customer_warn_num = res.custom_num+res.order_num+res.overday_num
          this.$store.commit("CustomerWarn/SET_DATA", {
            key: "saveMinTime",
            data: new Date(res.start_time),
          });
          this.titleArr[1].message = res.custom_num
          this.titleArr[2].message = res.overday_num
          this.titleArr[3].message = res.order_num
          this.minDate = new Date(res.start_time)
          for (let i in res.data) {
            for (let j in res.data[i].list) {
              res.data[i].list[j].active = false;
            }
            this.data.push(res.data[i])
          }
          if(res.data.length !== 0) {
            this.lastText = false
            this.lostPageShow = false
            this.sendMassage = true
            this.lostShow = false
            this.noRootShow = false
            this.dataShow = true
            this.allChooseActive = false
          }else {
            if(this.data.length !== 0) {
              this.lastText = true
              this.lostPageShow = false
              this.lostShow = false
              this.sendMassage = true
              this.noRootShow = false
            }else {
              this.lastText = false
              this.sendMassage = false
              DownScrollLoad.remove(this.DownScrollFN);
              if(this.userInfo.is_overdue==0) {
                this.dataShow = true
                this.noRootShow = false
                this.lostPageShow = true
              }else if(this.userInfo.is_overdue==1) {
                this.lostShow = false
                if(this.startTime==res.default_start_time && this.endTime==res.default_end_time && this.titleIndex==0) {
                  this.noRootShow = true
                  this.lostPageShow = false
                  this.dataShow = false
                }else {
                  this.noRootShow = false
                  this.lostPageShow = true
                  this.dataShow = true
                }
                
              }
            }
          }
          if(this.data.length == 0) {
            this.$store.commit('CustomerWarn/offset_set', 0)
          }else {
            let num = 0
            for(let i in this.data) {
              num += this.data[i].list.length
            }
            this.$store.commit('CustomerWarn/offset_set', num)
          }
        });
      }
    },
    // 点击选择店铺
    stroeChoose(index, _index) {
      this.data[index].list[_index].active = !this.data[index].list[_index].active
      this.$forceUpdate();

      let typeArr = [];
      this.data.forEach((item) => {
        item.list.forEach((_item) => {
          typeArr.push(_item.active);
        });
      });
      // 判断是否全部点击全选
      if (typeArr.findIndex((target) => target === false) == -1) {
        this.allChooseActive = true;
      } else {
        this.allChooseActive = false;
      }
    },
    // 全选
    allChoose() {
      this.allChooseActive = !this.allChooseActive;
      for (let i in this.data) {
        for (let j in this.data[i].list) {
          this.data[i].list[j].active = this.allChooseActive;
        }
      }
    },
    cancelTan() {
      this.tanDivShow = false;
    },
    // 群发消息
    sendNews() {
      this.$store.dispatch('Public/inH5Record',{btn_name:'客户预警群发消息'})
      
      Dialog.alert({
        title: "",
        message: "该功能正在开发中\n请耐心等待",
        showConfirmButton: false,
        showCancelButton: true,
        cancelButtonText: "关闭",
        width: "80vw",
        className: "CustomerWarnTan",
      }).catch(() => {});
    },
    changTab(index, name) {
      this.$store.dispatch('Public/inH5Record',{btn_name:'客户预警', page_param:{titleName:name}})
      this.titleIndex = index;

      this.warning_type = this.titleArr[index].value
      this.$store.commit('CustomerWarn/offset_set', 0)
      this.data = []
      this.allChooseActive = false
      for (let i in this.data) {
        for (let j in this.data[i].list) {
          this.data[i].list[j].active = false;
        }
      }
      this.getData();
    },
    // 跳转到详情页
    jump_stroe(name,buyerOpenuid) {
      this.$router.push({ 
        path:'CustomerInfo_APP', 
        query: {
          source:'3', 
          ww_nick: name,
          is_in_list: 1,
          buyer_openuid:buyerOpenuid
      }})
    },
    timeChoose(index) {
      this.timeIndex = index;

      if(index == 0) {
        this.minDate = this.saveMinTime
        this.maxDate = new Date(this.endTime)
        this.currentDate = new Date(this.startTime)
      }
      if(index == 1) {
        this.minDate = new Date(this.startTime)
        this.maxDate = new Date()
        this.currentDate = new Date(this.endTime)
      }
      
      this.timeShow = true;
    },
    timeValue() {
      this.timeShow = false;
      this.allChooseActive = false
      let d = new Date(this.currentDate);
      if (this.timeIndex == 0) {
        let startTime =
          d.getFullYear() + "-" + ((d.getMonth() + 1)>=10 ?d.getMonth() + 1 :`0${d.getMonth() + 1}`) + "-" + (d.getDate()>=10 ?d.getDate() :`0${d.getDate()}`);
        
        this.$store.commit("CustomerWarn/SET_DATA", {
          key: "startTime",
          data: startTime
        });
      }
      if (this.timeIndex == 1) {
        let endTime =
          d.getFullYear() + "-" + ((d.getMonth() + 1)>=10 ?d.getMonth() + 1 :`0${d.getMonth() + 1}`) + "-" + (d.getDate()>=10 ?d.getDate() :`0${d.getDate()}`);
        this.$store.commit("CustomerWarn/SET_DATA", {
          key: "endTime",
          data: endTime
        });
      }
      
      this.$store.commit('CustomerWarn/offset_set', 0)
      this.data = []
      this.getData();
    },
    colseTime() {
      this.timeShow = false;
      this.currentDate = this.timeIndex==0 ?new Date(this.startTime) : new Date(this.endTime)
    },
    DownScrollFN() {
      this.getData();
    },
    // 取整
    getInt(num) {
      if(Number(num)) {
        if (num < 10000) {
          return parseInt(num);
        } else {
          return parseInt(num / 10000);
        }
      }else {
        return '0'
      }
    },
    // 取小数
    getFixed(num) {
      if(Number(num)) {
        if (num < 10000) {
          let str = String(num).split(".")[1];
          if (str) {
            if(str.length < 2) {
              if(Number(str) < 10 && str !== '00') {
                str = str + '0'
              }
            }
            return str;
          } else {
            return "00";
          }
        } else {
          let str = String((Math.floor(((num / 10000) * 100)) / 100)).split(".")[1]
          if (str) {
            if(str.length < 2) {
              if(Number(str) < 10 && str !== '00') {
                str = str + '0'
              }
            }
            return str;
          } else {
            return "00";
          }
        }
      }else {
        return '00'
      }
    },
    init() {
      if(this.$store.state.Public.WarnData) {
        setTimeout(()=>{
          document.getElementById('CustomerWarn').scrollTo(0, this.scrollTopValue)
        },0)
        if(this.$store.state.Public.WarnData.page!==0) {
          this.$store.commit('CustomerWarn/offset_set', this.$store.state.Public.WarnData.page)
        }
        if(this.$store.state.Public.WarnData.visitor_id) {
          this.visitor_id = this.$store.state.Public.WarnData.visitor_id
        }
        if(this.$store.state.Public.WarnData.start_time) {
          this.$store.commit("CustomerWarn/SET_DATA", {
            key: "startTime",
            data: this.startTime == '' ?this.$store.state.Public.WarnData.start_time :this.startTime
          });
        }
        if(this.$store.state.Public.WarnData.end_time) {
          this.$store.commit("CustomerWarn/SET_DATA", {
            key: "endTime",
            data: this.endTime == '' ?this.$store.state.Public.WarnData.end_time :this.endTime
          });
        }
        if(this.$store.state.Public.WarnData.minDate) {
          this.minDate = this.$store.state.Public.WarnData.minDate
        }
        if(this.$store.state.Public.WarnData.titleIndex) {
          this.titleIndex = this.$store.state.Public.WarnData.titleIndex
        }
        if(this.$store.state.Public.WarnData.warning_type) {
          this.warning_type = this.$store.state.Public.WarnData.warning_type
          for(let i in this.titleArr) {
            if(this.titleArr[i].value == this.warning_type) {
              this.titleIndex = i
            }
          }
        }
        this.titleArr[1].message = this.$store.state.Public.WarnData.custom_num
        this.titleArr[2].message = this.$store.state.Public.WarnData.overday_num
        this.titleArr[3].message = this.$store.state.Public.WarnData.order_num

      }
      if(!(this.CustomerWarnData && this.CustomerWarnData.length > 0)) {
        this.getData()
      }else {
        this.dataShow = true
        this.sendMassage = true
        this.data = this.CustomerWarnData
      }
    },
    jump_router() {

      if (this.$config.WebOS == "wx") {
        this.popup_show = true;
        if (!window.location.hash.includes("jump_link=1")) {
          history.replaceState({}, 0, window.location.href + "?jump_link=1");
        }
        if (this.$config.SystemOS == "IOS") {
          this.popup_img = this.$OSS + "renew_tips_ios.png";
        } else {
          this.popup_img = this.$OSS + "renew_tips_android.png";
        }
      } else {
        window.open(URL5);
      }
    },
    popup_close() {
      if (window.location.hash.includes("jump_link=1")) {
        history.replaceState(
          {},
          0,
          window.location.href.replace("?jump_link=1", "")
        );
      }
    },
  },
  
  mounted() {
    this.userInfo = this.$store.state.Public.AccountInfo



    if(this.userInfo.is_boss == 0) {
      this.dataShow = false
      this.noRootShow = false
      this.lostShow = true
    }else {
      this.init()
    }
   
    
  },
  beforeDestroy() {
    DownScrollLoad.remove(this.DownScrollFN);
    let obj = {
      minDate: this.minDate, 
      titleIndex: this.titleIndex,
      custom_num: this.titleArr[1].message,
      overday_num: this.titleArr[2].message,
      order_num: this.titleArr[3].message,}
    let data = { ...this.dataObj, ...obj };
    this.$store.commit("Public/SET_DATA",{key:'WarnData', data: data})
  },
};
</script>